package org.example.project.service

object PasswordPolicy {
    const val REQUIREMENT_TEXT =
        "Passwort: mindestens 10 Zeichen, Groß- und Kleinbuchstabe sowie Sonderzeichen."

    fun isValid(password: String): Boolean = error(password) == null

    fun error(password: String): String? {
        val valid = password.length >= 10 &&
            password.any { it.isUpperCase() } &&
            password.any { it.isLowerCase() } &&
            password.any { !it.isLetterOrDigit() }
        return if (valid) null else REQUIREMENT_TEXT
    }
}
